"use strict";


/*****************
 ** WEBPACK FOOTER
 ** ./components/locale-provider/style/index.js
 ** module id = 204
 ** module chunks = 0
 **/